<template>
  <div>
    <AddressFormGroup v-on="$listeners" />

    <ServiceField ref="service" hidden v-on="$listeners" />
    <MarketSegmentField ref="marketSegment" hidden v-on="$listeners" />
  </div>
</template>

<script>
import AddressFormGroup from 'chimera/moving/components/form/parts/address/AddressFormGroup'
import { movingDefaultNL } from 'chimera/moving/service'
import MarketSegmentField from 'chimera/all/components/form/fields/marketSegment/MarketSegmentField'
import ServiceField from 'chimera/all/components/form/fields/service/ServiceField'

export default {
  name: 'MovingFromAddressFormPart',

  components: {
    AddressFormGroup,
    MarketSegmentField,
    ServiceField,
  },

  /**
   */
  mounted() {
    const country = this.$store.getters['context/get']('country', 'nl')
    if (country === 'nl') {
      // Set default service to `moving-consumer`.
      this.$refs.service.setValue(movingDefaultNL.id)
      this.$refs.marketSegment.setValue('Particulier')
    }
  },
}
</script>
